import React, { useEffect, useRef } from "react";
import * as echarts from "echarts";
import { FormatMoney } from "../../../Helpers/FormatNumber";

// Barras verticales "Comparativo Anual" (venta total por año). `datosMock`
// es solo el valor por defecto de `datos` si nadie lo manda.
const datosMock = [
    { anio: "2023", total: 1450300 },
    { anio: "2024", total: 1780600 },
    { anio: "2025", total: 2190438 },
    { anio: "2026", total: 622400 },
];

export const ChartComparativoAnual = ({
    id = "chart-comparativo-anual",
    datos = datosMock,
}) => {
    const chartRef = useRef(null);

    useEffect(() => {
        const dom = chartRef.current;
        if (!dom) return;

        if (echarts.getInstanceByDom(dom)) {
            echarts.dispose(dom);
        }

        const myChart = echarts.init(dom);
        const formatMoneda = (value) => `$${FormatMoney(value, 0)}`;

        const option = {
            tooltip: {
                trigger: "axis",
                axisPointer: { type: "shadow" },
                formatter: (params) => `${params[0].name}<br/>${formatMoneda(params[0].value)}`,
            },
            grid: { left: "8%", right: "4%", top: "10%", bottom: "10%", containLabel: true },
            xAxis: {
                type: "category",
                data: datos.map((item) => item.anio),
                axisLine: { lineStyle: { color: "#ccc" } },
                axisLabel: { color: "#333", fontSize: 11 },
            },
            yAxis: { type: "value", show: false },
            series: [
                {
                    type: "bar",
                    data: datos.map((item) => item.total),
                    barMaxWidth: 32,
                    itemStyle: { color: "#4a9e3c", borderRadius: [4, 4, 0, 0] },
                    label: {
                        show: true,
                        position: "top",
                        formatter: (params) => formatMoneda(params.value),
                        color: "#255220",
                        fontWeight: "bold",
                        fontSize: 10,
                    },
                },
            ],
        };

        myChart.setOption(option);

        const handleResize = () => myChart.resize();
        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
            myChart.dispose();
        };
    }, [datos]);

    return <div id={id} ref={chartRef} style={{ width: "100%", height: "100%" }} />;
};
